var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hand"},_vm._l((_vm.items),function(item,index){return _c('span',{key:index,staticClass:"spanreg",class:_vm.classview(item, index),on:{"click":function($event){return _vm.selData(index)}}},[_c('strong',[_vm._v(_vm._s(item.nombre)+":")]),_vm._v(" "),_c('span',{staticClass:"fontMono"},[_vm._v(_vm._s(item.input)),(item.inputrich)?_c('span',[_vm._v(" - "+_vm._s(item.inputrich))]):_vm._e()])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-056d9592","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/facturar/componentsfra/Viewitems.vue
// module id = 736
// module chunks = 0